// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getMessaging, getToken, isSupported } from "firebase/messaging";
import env from "./env";

// LocalStorage key for FCM token
const FCM_TOKEN_KEY = 'fcm_token';

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: env.FIREBASE_API_KEY,
    authDomain: env.FIREBASE_AUTH_DOMAIN,
    projectId: env.FIREBASE_PROJECT_ID,
    storageBucket: env.FIREBASE_STORAGE_BUCKET,
    messagingSenderId: env.FIREBASE_MESSAGE_SENDER_ID,
    appId: env.FIREBASE_APP_ID,
    measurementId: env.FIREBASE_MEASURMENT_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
if (typeof window !== "undefined") {
    const analytics = getAnalytics(app);
}

export const getFirebaseMessageToken = async () => {
    // debugger
    let isSupport = await isSupported()
    if (isSupport) {
        const messaging = getMessaging(app);
        console.log('messaging', messaging);
        console.log('app', app);
        console.log('firebaseConfig', firebaseConfig);

        try {
            let tokenId = await getToken(messaging, { vapidKey: env.FIREBASE_VAP_ID_KEY, })
            console.log('tokenId', tokenId);
            return { tokenId }
        } catch (error) {
            console.log('getFirebaseMessageToken', error);
            return { error }
        }
    }
    else {
        console.log('err');

        return { error: " Notification Not Supported" }
    }
}

// Get stored FCM token from localStorage
export const getStoredFCMToken = (): string | null => {
    if (typeof window !== 'undefined') {
        return localStorage.getItem(FCM_TOKEN_KEY);
    }
    return null;
};

// Save FCM token to localStorage
export const saveFCMToken = (token: string): void => {
    if (typeof window !== 'undefined') {
        localStorage.setItem(FCM_TOKEN_KEY, token);
    }
};

// Clear FCM token from localStorage (useful on logout)
export const clearFCMToken = (): void => {
    if (typeof window !== 'undefined') {
        localStorage.removeItem(FCM_TOKEN_KEY);
    }
};

export const requestNotification = async () => {
    try {
        // Check if we already have a token stored
        const storedToken = getStoredFCMToken();
        if (storedToken) {
            console.log('Using stored FCM token:', storedToken);
            return storedToken;
        }

        console.log(typeof Notification?.permission);
        console.log(Notification?.permission);
        console.log(Notification?.permission !== 'denied');

        if (!("Notification" in window)) {
            console.log("This browser does not support desktop notification");
            return ""
        }
        else if (Notification?.permission === "granted") {
            let { tokenId, error } = await getFirebaseMessageToken()

            if (error) {
                console.log("enableNotification error", error);
                return ""
            }
            console.log(tokenId);
            
            // Store the token for future use
            if (tokenId) {
                saveFCMToken(tokenId);
            }

            return tokenId
        }
        else if (Notification?.permission !== 'denied') {
            if (Notification?.permission === 'default') {
                const permission = await Notification.requestPermission();
                console.log('permission', permission);
                
                if (permission === "granted") {
                    let { tokenId, error } = await getFirebaseMessageToken()
                    if (error) {
                        console.log("enableNotification error", error);
                        return ""
                    }
                    
                    // Store the token for future use
                    if (tokenId) {
                        saveFCMToken(tokenId);
                    }
                    
                    return tokenId

                } else {
                    console.log("permission", permission);
                    return ""
                }
            }
        } else {
            return ""
        }

    } catch (error) {
        console.log('requestNotification error', error);
        return ""
    }
}